export const BACKEND_SERVER = "https://whdbackend.herokuapp.com"